<template>
  <div class="auth-form-section signup-form">
    <div class="content">
      <h6 v-if="viaLink || viaEmail">
        {{ $t("common.invited_by") }} {{ organizationName }}
      </h6>
      <api-errors :errors="errors" />
      <el-form class="auth-form" :model="form" :rules="rules" ref="form">
        <elsa-input
          name="email"
          :label="$t('sign_up.email_field.label')"
          :placeholder="$t('sign_up.email_field.placeholder')"
          v-model.trim.lazy="form.email"
        >
          {{ $t("sign_up.email_field.label") }}
        </elsa-input>
        <el-row justify="space-between">
          <el-col :xs="24" :sm="12">
            <elsa-input
              name="firstName"
              :label="$t('sign_up.first_name_field.label')"
              :placeholder="$t('sign_up.first_name_field.placeholder')"
              v-model.lazy="form.firstName"
              style="padding-right: 5px"
            >
              {{ $t("sign_up.first_name_field.label") }}
            </elsa-input>
          </el-col>
          <el-col :xs="24" :sm="12">
            <elsa-input
              name="lastName"
              :label="$t('sign_up.last_name_field.label')"
              :placeholder="$t('sign_up.last_name_field.placeholder')"
              v-model.lazy="form.lastName"
              style="padding-left: 5px"
            >
              {{ $t("sign_up.last_name_field.label") }}
            </elsa-input>
          </el-col>
        </el-row>
        <elsa-input
          v-if="!(viaLink || viaEmail)"
          name="companyName"
          :label="$t('sign_up.company_name_field.label')"
          :placeholder="$t('sign_up.company_name_field.placeholder')"
          v-model.lazy="form.companyName"
        >
          {{ $t("sign_up.last_name_field.label") }}
        </elsa-input>
        <elsa-select
          v-if="!(viaLink || viaEmail)"
          name="companyType"
          :label="$t('sign_up.company_type_field.label')"
          :placeholder="$t('sign_up.company_type_field.placeholder')"
          :options="companyType"
          v-model.lazy="form.companyType"
        />
        <elsa-input
          name="password"
          type="password"
          :label="$t('sign_up.password_field.label')"
          :placeholder="$t('sign_up.password_field.placeholder')"
          v-model.lazy="form.password"
        >
          {{ $t("sign_up.password_field.label") }}
        </elsa-input>
        <elsa-input
          name="confirmPassword"
          type="password"
          :label="$t('sign_up.confirm_password_field.label')"
          :placeholder="$t('sign_up.confirm_password_field.placeholder')"
          v-model.lazy="form.confirmPassword"
        >
          {{ $t("sign_up.confirm_password_field.label") }}
        </elsa-input>
        <div v-if="passNote.length > 0">
          <label>{{ $t("sign_up.password_field.label") }}</label>
          <ul id="passNote">
            <li v-for="item in passNote" :key="item.message">
              {{ item.message }}
            </li>
          </ul>
        </div>

        <primary-button
          class="elsa-primary-button"
          type="submit"
          v-loading.fullscreen.lock="fullscreenLoading"
          ref="submit"
          @click.native="handleSignUp"
          disabled
        >
          {{
            viaLink || viaEmail
              ? $t("sign_up.signup_accept_invitation")
              : $t("sign_up.sign_up")
          }}
        </primary-button>
      </el-form>
      <!--
      <div class="divider">
      </div>
      <secundary-button
        @click.native="handleNetworkLogin('facebook')"
        class="elsa-social-button"
        customIcon="facebook-logo"
        :iconLeft="true"
      >
        Facebook
      </secundary-button>
      -->
      <p class="terms">
        {{ $t("sign_up.by_signing_up_to_elsa") }}
        <a href="https://elsaspeak.com/terms" target="_blank">
          {{ $t("common.terms_of_use") }}
        </a>
        {{ $t("common.and") }}
        <a href="https://elsaspeak.com/privacy" target="_blank">
          {{ $t("common.privacy_policy") }}
        </a>
        {{ $t("sign_up.to_our") }}
      </p>
    </div>
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
// import SecundaryButton from '@/components/common/buttons/SecundaryButton'
import ElsaInput from "@/components/common/Input";
import ApiErrors from "@/components/common/ApiErrors";
// import axios from "@/utils/axios";
import {
  handleFormValidation,
  handleSubmitButtonState,
  isPropEmpty,
} from "@/helpers/formValidationHelper";
import { compose, pathOr, invoker } from "ramda";
import { mapActions } from "vuex";
import { firebaseAuth } from "@/utils/firebase";
import ElsaSelect from "@/components/common/Select";

export default {
  components: {
    ElsaSelect,
    PrimaryButton,
    // SecundaryButton,
    ElsaInput,
    ApiErrors,
  },
  props: {
    viaLink: {
      default: false,
    },
    viaEmail: {
      default: false,
    },
    organizationName: {
      type: String,
    },
    organizationEmail: {
      type: String,
    },
    organizationToken: {
      type: String,
    },
    organizationFirstName: {
      type: String,
    },
    organizationLastName: {
      type: String,
    },
    inviteTokenValid: {
      type: Boolean,
    },
  },
  data() {
    const isValidPwd = (value) => {
      this.passNote = [];
      let isValid = true;
      if (!value.match(/(?=.{8,}$)/)) {
        this.passNote.push({
          message: this.$t('sign_up.password_field.validations.long'),
        });
        isValid = false;
      }
      // if (!value.match(/(?=.*[a-z])/)) {
      //   this.passNote.push({
      //     message: this.$t('sign_up.password_field.validations.lowercase'),
      //   });
      //   isValid = false;
      // }
      if (!value.match(/(?=.*[A-Z])/)) {
        this.passNote.push({
          message: this.$t('sign_up.password_field.validations.uppercase'),
        });
        isValid = false;
      }
      // if (!value.match(/(?=.*[0-9])/)) {
      //   this.passNote.push({
      //     message: this.$t('sign_up.password_field.validations.number'),
      //   });
      //   isValid = false;
      // }
      if (!value.match(/(?=.*[0-9(@^!"#$%&'()*+,-./:;<=>?])/)) {
        this.passNote.push({
          message: this.$t('sign_up.password_field.validations.number_or_special_char'),
        });
        isValid = false;
      }
      return isValid;
    };
    const validateNewPwd = (rule, value, callback) => {
      const isValid = isValidPwd(value);
      if (!isValid) {
        callback(new Error(this.$t('sign_up.password_field.validations.correct_newpwd')));
      } else {
        callback();
      }
    };
    const validateConfirmPwd = (rule, value, callback) => {
      const isValid = isValidPwd(this.form.password);
      if (!isValid) {
        callback(new Error(this.$t('sign_up.password_field.validations.correct_newpwd')));
      } else {
        if (this.form.password !== value) {
          callback(new Error(this.$t('sign_up.password_field.validations.pwd_match')));
        } else {
          callback();
        }
      }
    };
    return {
      form: {},
      codeLength: 5,
      errors: [],
      rules: {
        email: [
          {
            required: true,
            message: this.$t('sign_up.email_field.validation_msg'),
            trigger: ["blur", "change"],
          },
          {
            type: "email",
            message: this.$t('sign_up.email_field.correct_validation_msg'),
            trigger: ["blur", "change"],
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('sign_up.password_field.validations.input_pwd'),
            trigger: ["blur", "change"],
          },
          { validator: validateNewPwd, trigger: ["blur", "change"] },
        ],
        confirmPassword: [
          {
            required: true,
            message: this.$t('sign_up.password_field.validations.input_confirm_pwd'),
            trigger: ["blur", "change"],
          },
          { validator: validateConfirmPwd, trigger: ["blur", "change"] },
        ],
        firstName: {
          required: true,
          message: this.$t('sign_up.first_name_field.validation_msg'),
          trigger: ["blur", "change"],
        },
        lastName: {
          required: true,
          message: this.$t('sign_up.last_name_field.validation_msg'),
          trigger: ["blur", "change"],
        },
        companyName: {
          required: true,
          message: this.$t('sign_up.company_name_field.validation_msg'),
          trigger: ["blur", "change"],
        },
        companyType: {
          required: true,
          message: this.$t('sign_up.company_type_field.validation_msg'),
          trigger: ["blur", "change"],
        },
      },
      fullscreenLoading: false,
      companyType: [
        {
          label: this.$t('sign_up.company_type.education'),
          value: "school",
        },
        {
          label: this.$t('sign_up.company_type.non_education'),
          value: "company",
        },
      ],
      passNote: [],
      // siteKey: process.env.VUE_APP_CAPTCHA_KEY,
      captcha: '',

    };
  },
  methods: {
    handleCode(code) {
      this.form.code = code;
    },
    async handleSignUp(e) {
      e.preventDefault();
      await this.recaptcha()
      this.loading = true
      handleFormValidation(this.$refs.form, this.signupRequest, () => {});
    },
    async recaptcha() {
      await this.$recaptchaLoaded()
      this.captcha = await this.$recaptcha('login')
    },
    async handleNetworkLogin(network) {
      try {
        if (network === "facebook") {
          return await this.handleFacebookSignIn();
        }
      } catch (errors) {
        return (this.errors = errors);
      }
    },
    handleFacebookSignIn() {
      return this.facebookSignIn().then(() => {
        const user = firebaseAuth.currentUser;
        const verifyInfoData = compose(
          pathOr({}, ["providerData", 0]),
          invoker(0, "toJSON")
        )(user);

        return this.$emit("close", {
          verifyInfo: true,
          verifyInfoData: {
            ...verifyInfoData,
            token: this.organizationToken,
            organizationName: this.getOrganizationInviteName,
          },
        });
      });
    },
    async signupRequest() {
      this.fullscreenLoading = true;
      const userData = {
        first_name: this.form.firstName,
        last_name: this.form.lastName,
        email: this.form.email,
        password: this.form.password,
        is_invite: this.viaEmail || this.viaLink,
      };
      try {
        handleSubmitButtonState(this.$refs.submit.$el, false);
        const { data, status } = await this.$store.dispatch(
          "auth/signUp",
          userData
        );
        if (status === 201 && !(this.viaEmail || this.viaLink)) {
          const organization = {
            name: this.form.companyName,
            type: this.form.companyType,
            user_id: data.id,
          };
          await this.$store.dispatch("auth/setupOrganization", organization);
        }

        this.$emit("close", {
          success: true,
          viaEmail: this.viaEmail,
          email: this.form.email,
          password: this.form.password,
          captcha: this.captcha,
        });
        this.fullscreenLoading = false;
      } catch (error) {
        this.fullscreenLoading = false;
        handleSubmitButtonState(this.$refs.submit.$el, true);
        this.errors = error;
      }
    },
    resetForm() {
      this.terms = false;
      this.form = {};
      this.errors = [];
    },
    onFormChange() {
      const isEmptyFields =
        isPropEmpty("email")(this.form) || isPropEmpty("password")(this.form);
      handleSubmitButtonState(this.$refs.submit.$el, !isEmptyFields);
    },
    ...mapActions({
      facebookSignIn: "auth/facebookSignIn",
    }),
  },
  mounted() {
    if (this.viaEmail) {
      this.form = {
        ...this.form,
        email: this.organizationEmail,
        firstName: this.organizationFirstName,
        lastName: this.organizationLastName,
      };
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        return this.onFormChange();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
h6 {
  font-size: 16px;
  line-height: 24px;
  margin-top: 15px;
  margin-bottom: 5px;
}
// .auth-page .auth-form-section h6 {
//   margin-top: 8px;
// }
::v-deep .el-form .el-form-item .el-form-item__label {
  text-transform: none;
}
//::v-deep .el-form .el-form-item {
//  margin-bottom: 41px;
//}
.auth-page .auth-form-section .content .elsa-primary-button {
  margin-top: 7px;
  width: 100%;
}
.elsa-social-button.el-button {
  width: 100%;
}
#passNote {
  color: #f56c6c;
}
</style>
